/**
 * Esquemas Zod del dominio de autenticación.
 *
 * El formulario de login se valida con `loginSchema`; el tipo del formulario se
 * **infiere** del esquema (`z.infer`), no se escribe dos veces
 * (`docs/frontend_conventions.md`).
 */
import { z } from "zod";

/** Validación del formulario de login: usuario y contraseña no vacíos. */
export const loginSchema = z.object({
  username: z.string().trim().min(1, "Ingresa tu usuario."),
  password: z.string().min(1, "Ingresa tu contraseña."),
});

/** Valores del formulario de login (inferidos del esquema). */
export type LoginValues = z.infer<typeof loginSchema>;
